import React from 'react';

function Blog() {
  return (
    <section>
      <h2>My Blog</h2>
      <p>No blog posts yet.</p>
    </section>
  );
}

export default Blog;